import React from 'react';
import RegisterForm from '../../components/auth/RegisterForm';
const Register = () => {
    return (
        <div>
            <h1 className='h1-register'>Création de compte</h1>
                <RegisterForm />
        </div>
    );
};
export default Register;